import { CommonError } from '../../types';
import { Contest } from '../../public/contest/types';
import { RankActions } from './actions';
import { FETCH_RANKS_FAILURE, FETCH_RANKS_REQUEST, FETCH_RANKS_SUCCESS } from './constants';
import { TopUser } from './types';


export interface RankState {
    topUsers: TopUser[];
    contestOfRank: Contest;
    loading: boolean;
    error: CommonError | null;
}
const initialState: RankState = {
    topUsers: [],
    contestOfRank: {
        contestId: null,
        contestName: '',
        startDateTime: new Date(),
        endDateTime: new Date(),
        banner: '',
        maxParticipants: 0,
    },
    loading: false,
    error: null,
};
export const rankReducer = (state = initialState, action: RankActions): RankState => {
    switch (action.type) {
        case FETCH_RANKS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_RANKS_SUCCESS: {
            state.loading = false;
            state.topUsers = action.payload.topUsers;
            state.contestOfRank = action.payload.contest;
            return { ...state };
        }
        case FETCH_RANKS_FAILURE:
            return { ...state, loading: false, error: null };
        default:
            return state;
    }
};
 